import { computed } from 'vue';
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { useDisplayName } from '@Shared';

const DEFAULT_FALLBACK = 'Your closing team';

/**
 * Resolves the display name for the company associated with the current request.
 * Uses the shared `useDisplayName` composable which follows the fallback chain:
 * Location DBA → Location Name → Brand DBA → Brand Name → Company DBA → Company Name.
 *
 * @param fallback - Text to display when no company information is available.
 *                   Defaults to "Your closing team". Use lowercase for mid-sentence placement.
 * @returns An object containing a reactive `companyName` computed ref.
 */
export default function useCompanyName(fallback = DEFAULT_FALLBACK) {
    const companyStore = useCompanyStore();
    const locationStore = useLocationStore();

    const { displayName } = useDisplayName(
        () => companyStore.company,
        () => locationStore.location,
    );

    const companyName = computed(() => displayName.value || fallback);

    return { companyName };
}
